import { render, staticRenderFns } from "./SearchSkills.vue?vue&type=template&id=62bdb71c&scoped=true&"
import script from "./SearchSkills.vue?vue&type=script&lang=js&"
export * from "./SearchSkills.vue?vue&type=script&lang=js&"
import style0 from "./SearchSkills.vue?vue&type=style&index=0&id=62bdb71c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bdb71c",
  null
  
)

export default component.exports